import DatePicker from 'react-date-picker'
import 'react-date-picker/dist/DatePicker.css'
import 'react-calendar/dist/Calendar.css'
import './contract-info.css'
import {ContractTypes} from 'utility/utility'
import moment from 'moment'

export const ContractInfo = props => {
  const {
    contractType,
    contractTypeProps = {},
    trialExpiry,
    contractExpiry,
    onContractTypeChange,
    onTrialExpiryChange,
    onContractExpiryChange
  } = props

  return (
    <>
      <div className="form-group row">
        <label className="col-sm-4 col-lg-5 col-form-label">Trial or Customer</label>
        <div className="col-sm-8 col-lg-7">
          <select
            className="form-control"
            value={contractType}
            onChange={e => onContractTypeChange(e)}
            {...contractTypeProps}
          >
            <option selected disabled>
              Select contract type
            </option>
            <option value={ContractTypes.Trial}>Trial</option>
            <option value={ContractTypes.Customer}>Customer</option>
            <option value={ContractTypes.FreePartnerAccount}>Free Partner Account</option>
            <option value={ContractTypes.MonthlyCreditCardCustomer}>Monthly Credit Card Customer</option>
            <option value={ContractTypes.AnnualCorporateCustomer}>Annual Corporate Customer</option>
          </select>
        </div>
      </div>
      {contractType === ContractTypes.Trial && (
        <div className="form-group row trial_expired_div">
          <label className="col-sm-4 col-lg-5 col-form-label">Trial Expires On</label>
          <div className="col-sm-8 col-lg-7">
            <DatePicker
              className="form-control"
              minDate={new Date()}
              onChange={date => onTrialExpiryChange(moment(date).toISOString())}
              value={trialExpiry ? moment(trialExpiry).toDate() : new Date()}
              calendarIcon={<i className="fal fa-calendar"></i>}
              clearIcon={<i className="fal fa-times"></i>}
            />
          </div>
          <div className="col-sm-8 col-lg-7 offset-lg-5 offset-sm-4">{props.children}</div>
        </div>
      )}

      {[ContractTypes.Customer, ContractTypes.AnnualCorporateCustomer].includes(contractType) && (
        <div className="form-group row contract_expired_div">
          <label className="col-sm-4 col-lg-5 col-form-label">Contract End Date</label>
          <div className="col-sm-8 col-lg-7">
            <DatePicker
              className="form-control"
              minDate={new Date()}
              onChange={date => onContractExpiryChange(moment(date).toISOString())}
              value={contractExpiry ? moment(contractExpiry).toDate() : new Date()}
              calendarIcon={<i className="fal fa-calendar"></i>}
              clearIcon={<i className="fal fa-times"></i>}
            />
          </div>
          <div className="col-sm-8 col-lg-7 offset-lg-5 offset-sm-4">{props.children}</div>
        </div>
      )}
    </>
  )
}
